<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('formularios') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li v-if="isPrestacaoServico">
                                    <a class="a-inativo">
                                        {{ $t('prestacao-servico') }}
                                    </a>
                                </li>
                                <li v-else>
                                    <a class="a-inativo">{{
                                        isPromotor ? $t('promotor') : $t('vendas')
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: `${abrev}formulario-list`,
                                            })
                                        "
                                        >{{ $t('formularios') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id && titulo ? titulo : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button 
                            class="delete-btn" 
                            type="button" 
                            tag="button" 
                            @click="redirectToPage()"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="permissao.read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJUNTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="permissao.read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <Geral
                    ref="geral"
                    v-if="abasAbertas['geral'] && !newToEdit && !editToDuplicate && permissao.read"
                    v-show="abas[abaSelecionada] == 'geral'"
                    :isUpdate="isUpdate"
                    @idFormulario="receiveIdFormularioFromChild"
                    @titulo="receiveTitulo"
                    @isChanged="isChanged = $event"
                    @redirect="redirect"
                />
            </div>
        </div>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

// Abas
import Geral from '@/components/promotor/formulario/abas/Geral';

export default {
    beforeRouteLeave(to, from, next) {
        if (
            from.name == `${this.abrev}formulario-new` &&
            to.name == `${this.abrev}formulario-edit`
        ) {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        } else if (
            from.name == `${this.abrev}formulario-edit` &&
            to.name == `${this.abrev}formulario-duplicate-new`
        ) {
            this.isUpdate = false;
            this.editToDuplicate = true;

            setTimeout(() => {
                this.editToDuplicate = false;
            }, 500);
        }

        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        HideInfo,
        Geral,
    },
    data() {
        return {
            id: 0,
            titulo: '',
            abaSelecionada: 0,
            abas: ['geral'],
            abasAbertas: {},
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            editToDuplicate: false,
            permissao: false,
            idFormulario: 0,

            abrev: '',
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
            isPrestacaoServico: this.$route.meta.contexto == 'prestacao-servico',

            permissions: this.$store.getters.permission,
            rotaTela: this.$route.query.tela,
            isAssociated: false,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        if (this.isPrestacaoServico) {
            this.permissao = this.hasPermissionAccess('prestacao-servico', 'formulario', 'serv-formulario');
            this.abrev = `${this.$route.meta.abrev}-`;
        } else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'formulario');
        } else if (this.isVenda) {
            this.abrev = this.$route.meta.contexto.slice(0, 3) + '-';
            this.permissao = this.hasPermissionAccess('vendas', 'formulario', 'ven-formulario');
        }
        
        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });
        } else {
            this.abasAbertas['geral'] = true;
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        receiveTitulo(titulo) {
            this.titulo = titulo;
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        receiveIdFormularioFromChild(id) {
            this.idFormulario = id;
        },
        redirect() {
            this.isAssociated = this.$route.query.isAssociated;
            this.redirectToPage();
        },
        /* 
            feito dessa forma para conseguir abrangir as telas de atendimento.
            O nome da rota eh igual ao condigo unico tela, por exemplo, 
            ven-motivo-atendimento isAssociated - checar se deseja associar agora ou não
        */
        redirectToPage() {
            let tempTela = '';
            let tempAba = 'formulario';

            if (this.rotaTela) {
                const foundObject = this.permissions.filter((obj) =>
                    this.rotaTela.includes(obj.codigounicotela)
                );

                if (foundObject) {
                    const objectSize = Object.keys(foundObject).length;
                    if (objectSize > 0) {
                        tempTela = this.rotaTela;

                        if (!this.isUpdate && this.isAssociated) {
                            const name = this.$t(foundObject[0].codigounicotela);

                            this.changeScreen(tempTela, tempAba, name);
                            this.isAssociated = false;
                        } else {
                            this.changeScreen(tempTela, tempAba);
                        }
                    }
                }
            } else {
                if (this.idFormulario > 0) {
                    this.$router.push({
                        name: `${this.abrev}formulario-edit`,
                        params: { id: this.idFormulario },
                    });
                } else {
                    setTimeout(() => {
                        this.$router.push({ name: `${this.abrev}formulario` });
                    }, 2000);
                }
                this.idFormulario = 0;
            }
        },
        changeScreen(tempTela, tempAba) {
            let query = {};
            if (tempAba != null) query.abaSelecionada = tempAba;
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: {
                        id: this.$route.query['id'],
                        uuid: this.$route.query.uuid,
                        descricao: this.$route.query['descricao'],
                    },
                    query: query,
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav-tabs-children {
            margin-bottom: 20px;

            li> ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                &~i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
